import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import * as Sentry from '@sentry/browser'

const instance = axios.create({
  baseURL: process.env.VUE_APP_CORE_URL
})
instance.defaults.paramsSerializer = params => {
  return qs.stringify(params, { arrayFormat: 'repeat' })
}
instance.interceptors.request.use(
  reqConfig => {
    if (Vue.prototype.$getCookie('comLoginToken')) {
      const xCorrelationId = Vue.prototype.$getGuid()
      reqConfig.headers = {
        KingnetAuth: 'Cookies ' + Vue.prototype.$getCookie('comLoginToken').split('token=').pop(),
        'X-Correlation-Id': xCorrelationId
      }
      Sentry.setTag('X-Correlation-Id', xCorrelationId)
      return reqConfig
    } else {
      Vue.prototype.$alert('登入過期或驗證失敗，請重新登入', '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        router.push({ name: 'LoginMain' })
      })
    }
  },
  err => {
    return Promise.reject(err)
  }
)
instance.interceptors.response.use(
  res => res,
  err => {
    // eslint-disable-next-line eqeqeq
    if (err && err.response && (err.response.status == 401 || err.response.status == 403)) {
      if (err.response.data.ErrorMessage || err.response.data.Message) {
        const message = err.response.data.ErrorMessage ? err.response.data.ErrorMessage.Description : err.response.data.Message
        Vue.prototype.$alert(message, '警告', {
          confirmButtonText: '確認',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          // eslint-disable-next-line eqeqeq
          if (err.response.status == 401) { router.push({ name: 'LoginMain' }) }
        })
        return Promise.reject(err)
      }
    } else if (err && err.response && err.response.status === 409) {
      Vue.prototype.$alert(err.response.data.ErrorMessage.Description, '警告', {
        confirmButtonText: '確認',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        // eslint-disable-next-line eqeqeq
        if (err.response.status == 404) { router.push({ name: 'LoginMain' }) }
      })
      return Promise.reject(err)
    } else {
      return Promise.reject(err)
    }
  }
)

// Swagger: https://local.kingnetsmart.com.tw/core/index.html#/ManagerClock
export const apiManagement = {
  PostAuthorizationCarrier: (requestData, config) => instance.post('/api/AuthorizationCarrier', requestData, config), // 開通載具
  DeleteAuthorizationCarrier: (requestData, config) => instance.delete('/api/AuthorizationCarrier', Object.assign({}, { data: requestData }, config)), // 解除載具
  GetPostAuthorizationCarrierValidation: (requestData, config) => instance.get('/api/AuthorizationCarrier/Bind/Validation', Object.assign({}, { params: requestData }, config)), // 取得是否可以開通載具
  GetDeleteAuthorizationCarrierValidation: (requestData, config) => instance.get('/api/AuthorizationCarrier/Exist', Object.assign({}, { params: requestData }, config)), // 取得是否可以解除載具
  GetDeviceList: (requestData) => instance.get(`/api/AuthorizationAccounts/${requestData.id}/Carrier`), // 取得載具列表
  PutDeviceNote: (queryPath, requestData, config) => instance.put(`/api/AuthorizationAccounts/Authorization/Carrier/${queryPath}`, requestData, config), // 更新載具備註
  PostDevice: (queryPath, requestData, config) => instance.post(`/api/AuthorizationAccounts/${queryPath}/Carrier`, requestData, config), // 幫其他帳號開通載具
  DeleteDevice: (queryPath, requestData, config) => instance.delete(`/api/AuthorizationAccounts/Authorization/Carrier/${queryPath}`, Object.assign({}, { data: requestData }), config), // 幫其他帳號解除載具
  PutInfo: (requestData, config) => instance.put('/ChangeAuthorizationName', requestData, config), // 更新個人資料姓名
  PostPassword: (requestData, config) => instance.post('/ChangePassword', requestData, config) // 更新密碼
}
